import { createComponent } from '@mtfe/sweet';
import tpl from './dom.html';
import style from './style.less';

const defaultWelfareIndex = '福利';
const defaultSubtitle = '';

const WelfareCardReady = () => {};
/**
 * 福利卡片
 * @param {object} props 福利卡片参数
 * @param {string} [props.welfareIndex='福利'] 福利卡片序号，展示在左上角
 * @param {string} props.title 卡片标题
 * @param {string} [props.subtitle=''] 卡片副标题
 * @param {string} props.innerComponent 内部展示的组件
 * @param {}
 * @returns
 */
const WelfareCard = (props = {}) => {
    const {
        welfareIndex = defaultWelfareIndex,
        title,
        subtitle = defaultSubtitle,
        innerComponent,
        subtitleID,
        isContainerGradient = false,
    } = props;

    if (title === undefined) {
        throw new Error('WelfareCard Error: The parameter title is missing.');
    }
    if (innerComponent === undefined) {
        throw new Error('WelfareCard Error: The parameter innerComponent is missing.');
    }

    const data = {
        welfareIndex,
        title,
        subtitle,
        innerComponent,
        subtitleID,
    };
    const events = {};
    if (isContainerGradient) {
        style.container = style.containerGradient;
    }
    return createComponent(tpl, { data, style }, events);
};

export default WelfareCard;
